import styled from "@emotion/styled";
import { TERMINAL_FONT_FAMILY } from "./constants";

// Base terminal-style container
export const TerminalContainer = styled.div`
  font-family: ${TERMINAL_FONT_FAMILY};
  background-color: var(--gray-1);
  border: 2px solid var(--gray-7);
  border-radius: 6px;
  padding: 16px;
`;

// Terminal-style text with monospace font
export const TerminalText = styled.div<{
  size?: "xs" | "sm" | "md" | "lg";
  color?: string;
}>`
  font-family: ${TERMINAL_FONT_FAMILY};
  font-size: 13px;
  color: ${({ color = "var(--gray-12)" }) => color};
`;

// Small action button with consistent styling
export const SmallActionButton = styled.div`
  font-size: 13px;
  padding: 2px 4px;
`;

// Common error message styling
export const ErrorContainer = styled.div`
  padding: 12px;
  margin-top: 12px;
  background-color: var(--red-2);
  border-radius: 4px;
  border: 2px solid var(--red-6);
  font-family: ${TERMINAL_FONT_FAMILY};
  font-size: 13px;
`;
